import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

interface HeaderOptions {
  token?: string;
  locale?: string;
  patient?: { psId?: string } | null;
  stream?: boolean;
  providerId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class HttpHeadersService {
  getHeaders(options: HeaderOptions): Record<string, string> {
    const headers: Record<string, string> = {
      ...(options.stream && { Accept: 'text/event-stream, application/json, text/plain' })
    };

    if (options.token) {
      headers.Authorization = `Bearer ${options.token}`;
    }

    if (options.locale) {
      headers['Accept-Language'] = options.locale;
    }

    if (options.providerId) {
      headers['X-LAD-Provider-ID'] = options.providerId;
    }

    // Workaround to avoid validate PS token in Dev. (token is invalid because is generated by PS auth0 configuration)
    if (environment.ENVIRONMENT !== 'production' && options.patient?.psId) {
      headers['Ps-Id'] = `${options.patient.psId}`;
    }

    return headers;
  }
}
